import { initializeApp, getApps, type FirebaseApp, type FirebaseOptions } from "firebase/app";

// Shared across iam, storage, and database so multiple mksys projects
// pointing at the same Firebase project reuse one FirebaseApp instead of
// racing `initializeApp` and hitting `duplicate-app`.
const apps = new Map<string, FirebaseApp>();

export function getFirebaseApp(options: FirebaseOptions): FirebaseApp {
    const name = `app-${options.projectId}`;
    const cached = apps.get(name);
    if (cached) return cached;
    const existing = getApps().find(a => a.name === name);
    if (existing) {
        apps.set(name, existing);
        return existing;
    }
    const app = initializeApp(options, name);
    apps.set(name, app);
    return app;
}
